import React from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useTheme,
} from "@mui/material";

const fundDisclosures = [
    {
        amc: "HDFC Mutual Fund",
        equity: "0.15%-1.35%",
        debt: "0.13%-1.00%",
    },
    {
        amc: "SBI Mutual Fund",
        equity: "0.18%-1.42%",
        debt: "0.05%-1.26%",
    },
    {
        amc: "UTI MUTUAL FUND",
        equity: "0.12%-1.71%",
        debt: "0.06%-1.24%",
    },
    {
        amc: "ICICI Prudential Mutual Fund",
        equity: "0.04%-1.30%",
        debt: "0.04%-0.98%",
    },
    {
        amc: "NIPPON INDIA MUTUAL FUND",
        equity: "0.17%-1.40%",
        debt: "0.07%-1.44%",
    },
];

export default function Disclosures() {
    const theme = useTheme();

    return (
        <Box sx={{ backgroundColor: "#fff", minHeight: "100vh" }}>
            {/* Header */}
            <Box
                sx={{
                    pt: { xs: 10, md: 14 },
                    pb: { xs: 6, md: 2 },
                    px: 2,

                }}
            > <Container maxWidth="md">
                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            textAlign: "center",
                            lineHeight: 1.1,
                            mb: 3,
                            animation: "fadeUp 0.9s ease-out both",
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        Fund{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            Disclosures </Box> </Typography>


                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 700,
                            fontSize: { xs: 18, md: 22 },
                            textAlign: "center",
                            mb: 1.5,
                        }}
                    >
                        Commission Rates
                    </Typography>

                    <Typography
                        sx={{
                            textAlign: "center",
                            fontSize: { xs: 13, md: 15 },
                            color: "#555",
                            lineHeight: 1.8,
                            maxWidth: 700,
                            mx: "auto",
                        }}
                    >
                        ArthGyan may earn commissions from mutual fund companies on investments
                        made through our platform. These commissions vary by AMC and scheme category
                        and do not solely determine our fund selection. The applicable commission
                        rates are listed below and updated periodically.
                    </Typography>
                </Container>
            </Box>

            {/* Commission Table */}
            <Box
                sx={{
                    pb: { xs: 5, md: 8 },
                    px: { xs: 2, md: 4 },
                    maxWidth: 1200,
                    mx: "auto",
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: "18px",
                        overflow: "hidden",
                        border: "2px solid #00a8a8",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                        "&:hover": {
                            boxShadow: "0 15px 30px rgba(0,0,0,0.10)",
                        },
                    }}
                >
                    <TableContainer sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 560, tableLayout: "fixed" }}>
                            <TableHead>
                                <TableRow
                                    sx={{
                                        background: `linear-gradient(90deg, ${theme.palette.primary.main})`,
                                    }}
                                >
                                    <TableCell
                                        sx={{
                                            width: "44%",
                                            color: "#fff",
                                            fontWeight: 800,
                                            fontSize: { xs: 12, sm: 14 },
                                            py: 2.5,
                                            pl: { xs: 2, md: 3 },
                                        }}
                                    >
                                        AMC Name
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "28%",
                                            color: "#fff",
                                            fontWeight: 800,
                                            fontSize: { xs: 12, sm: 14 },
                                            px: 1,
                                            py: 2.5,
                                        }}
                                    >
                                        Equity Funds
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "28%",
                                            color: "#fff",
                                            fontWeight: 800,
                                            fontSize: { xs: 12, sm: 14 },
                                            px: 1,
                                            py: 2.5,
                                        }}
                                    >
                                        Debt Funds
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {fundDisclosures.map((fund, index) => (
                                    <TableRow
                                        key={fund.amc}
                                        sx={{
                                            backgroundColor:
                                                index % 2 === 0 ? "#fff" : "#F5FAFF",
                                            transition: "background-color 0.2s ease",
                                            "&:hover": {
                                                backgroundColor: "#E9F7FF",
                                            },
                                            "&:last-child td": {
                                                borderBottom: 0,
                                            },
                                        }}
                                    >
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                color: theme.palette.text.primary,
                                                fontSize: { xs: 12, sm: 14 },
                                                py: 2.5,
                                                pl: { xs: 2, md: 3 },
                                                overflowWrap: "anywhere",
                                            }}
                                        >
                                            {fund.amc}
                                        </TableCell>

                                        <TableCell
                                            align="center"
                                            sx={{
                                                color: theme.palette.primary.main,
                                                fontWeight: 700,
                                                fontSize: { xs: 11, sm: 14 },
                                                px: 1,
                                                py: 2.5,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {fund.equity || "-"}
                                        </TableCell>

                                        <TableCell
                                            align="center"
                                            sx={{
                                                color: theme.palette.primary.main,
                                                fontWeight: 700,
                                                fontSize: { xs: 11, sm: 14 },
                                                px: 1,
                                                py: 2.5,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {fund.debt || "-"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                <Typography
                    sx={{
                        mt: 2.5,
                        px: 0.5,
                        fontSize: 12,
                        color: "#666",
                        lineHeight: 1.8,
                    }}
                >
                    Note: Commission figures are AMC-level ranges taken
                    from the supplied disclosure table. They should not be
                    interpreted as verified scheme-specific rates. Please
                    verify the latest applicable disclosures before publishing.
                </Typography>
            </Box>
        </Box>


    );
}
